import React from 'react'
import lazyWithReload from './utils/lazyWithReload'
import { Outlet, RouteObject } from 'react-router'
import { Navigate } from 'react-router-dom'
import { Page } from './components/Page'
import { Organization } from './graphql/query/organization'
import { Role } from './hooks/useRole'

const Contact = lazyWithReload(() => import('./pages/Contact'))
const ContactList = lazyWithReload(() => import('./pages/ContactList'))
const Contacts = lazyWithReload(() => import('./pages/Contacts'))
const Endpoint = lazyWithReload(() => import('./pages/Endpoint'))
const EndpointList = lazyWithReload(() => import('./pages/EndpointList'))
const Endpoints = lazyWithReload(() => import('./pages/Endpoints'))
const InProgress = lazyWithReload(() => import('./pages/InProgress'))
const InProgressAgent = lazyWithReload(() => import('./pages/InProgress/AgentCall'))
const Login = lazyWithReload(() => import('./pages/Login'))
const Logout = lazyWithReload(() => import('./pages/Logout'))
const Mailbox = lazyWithReload(() => import('./pages/Mailbox'))
const MailboxList = lazyWithReload(() => import('./pages/MailboxList'))
const Mailboxes = lazyWithReload(() => import('./pages/Mailboxes'))
const NotFound = lazyWithReload(() => import('./pages/NotFound'))
const Overview = lazyWithReload(() => import('./pages/Overview'))
const Organizations = lazyWithReload(() => import('./pages/Organizations'))
const Settings = lazyWithReload(() => import('./pages/Settings'))
const Source = lazyWithReload(() => import('./pages/Source'))
const SourceList = lazyWithReload(() => import('./pages/SourceList'))
const Sources = lazyWithReload(() => import('./pages/Sources'))

const Page404 = () => (
  <Page>
    <NotFound />
  </Page>
)

function routes(
  isLoggedIn: boolean = false,
  hasRole: (role: Role) => boolean,
  organizationIds: Organization[],
): RouteObject[] {
  return [
    {
      path: '/',
      element: isLoggedIn ? (
        hasRole('MANAGER') ? (
          <Overview />
        ) : (
          <InProgress />
        )
      ) : (
        <Navigate to="/login" state={{ from: '/' }} />
      ),
    },
    {
      path: 'in-progress',
      element: isLoggedIn ? (
        // hasRole('MANAGER') ? (
        <Outlet />
      ) : (
        // ) : (
        //   <Page404 />
        // )
        <Navigate to="/login" state={{ from: 'in-progress' }} />
      ),
      children: [
        { path: '', element: <InProgress /> },
        { path: ':id', element: <Contact /> },
        { path: 'agent/:id', element: <InProgressAgent /> },
      ],
    },
    {
      path: 'contacts',
      element: isLoggedIn ? (
        hasRole('MANAGER') ? (
          <Contacts />
        ) : (
          <Page404 />
        )
      ) : (
        <Navigate to="/login" state={{ from: 'contacts' }} />
      ),
      children: [
        { path: '', element: <ContactList /> },
        { path: ':id', element: <Contact /> },
      ],
    },
    { path: 'login', element: isLoggedIn ? <Navigate to="/" /> : <Login /> },
    { path: 'logout', element: <Logout /> },
    {
      path: 'settings',
      element: isLoggedIn 
        ? <Settings />
        : <Navigate to="/login" state={{ from: 'settings' }} />,
      children: [
        {
          path: 'mailboxes',
          element: hasRole('ADMIN')
            ? <Mailboxes />
            : <Page404 />,
          children: [
            { path: '', element: <MailboxList /> },
            { path: ':id', element: <Mailbox /> },
          ],
        },
        {
          path: 'endpoints',
          element: hasRole('ADMIN')
            ? <Endpoints />
            : <Page404 />,
          children: [
            { path: '', element: <EndpointList /> },
            { path: ':id', element: <Endpoint /> },
          ],
        },
        {
          path: 'organizations',
          element: organizationIds.length > 0
            ? <Organizations />
            : <Page404 />,
        },
      ],
    },
    {
      path: 'sources',
      element: isLoggedIn ? (
        hasRole('ADMIN') ? (
          <Sources />
        ) : (
          <Page404 />
        )
      ) : (
        <Navigate to="/login" state={{ from: 'sources' }} />
      ),
      children: [
        { path: '', element: <SourceList /> },
        { path: ':id', element: <Source /> },
      ],
    },
    {
      path: '*',
      element: isLoggedIn ? (
        <Page404 />
      ) : (
        <Navigate to="/login" state={{ from: '/' }} />
      ),
    },
  ]
}

export default routes
